<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">资产折旧</span>
      <span class="dark4-color ">提示：按 Ctrl + F 键并输入可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
      <Row type="flex" :space-x="10">
        <Cell><account-date-choose v-model="accountDate"/></Cell>
        <Cell :flex="1" class="text-right">
          <Button color="primary" @click="loadCode" :loading="loading">预加载</Button>
          <Button color="primary" @click="edit" :disabled="zhejiu" :loading="loading">计提折旧</Button>
        </Cell>
      </Row>
    </div>
    <div class="h-panel-body">
      <Table :datas="datas" :border="true">
        <TableItem title="序号" :width="50">
          <template v-slot="{ index }">{{ index + 1 }} </template>
        </TableItem>
        <TableItem title="会计期间" prop="checkDate"  ></TableItem>
        <TableItem title="计提折旧" prop="status"></TableItem>
        <TableItem title="凭证ID" prop="voucherId"></TableItem>
        <TableItem title="凭证号" prop="voucherName"></TableItem>
        <TableItem title="操作" align="center">
          <div class="actions" slot-scope="{data, index}">
<!--            <span @click="editvoucher(data)">查看凭证</span>-->
<!--            <router-link v-if="User.role!=='View'" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">查看凭证</router-link>-->
<!--            <router-link tag="span" :to="{name:'VoucherForm',params:{voucherId:data.voucherId}}">查看凭证</router-link>-->
            <span @click="viewVoucher(data)">查看凭证</span>
            <span v-if="index === 0" @click="remove(data)">撤销折旧</span>
          </div>
        </TableItem>
      </Table>
      <div class="margin-top-bottom">
        <Pagination v-model="pageInfo" align="center" layout="pager" small/>
      </div>
    </div>
  </app-content>
</template>
<script>
import {mapState} from 'vuex';
import moment from "moment/moment";
/**
 * 资产自动折旧。
 */
export default {
  name: 'AccrueDepreciation',
  data() {
    return {
      datas: [],
      fixedAssets: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      accountDate:null,
      // 表单数据对象，用于存储凭证相关信息
      form: {
        voucherId: '',
        // 凭证备注信息，初始为空字符串
        remark: '',
        // 凭证字号，例如“记”字，初始为空字符串
        word: '记',
        // 凭证编号，初始为空字符串
        code: 9999,
        // 凭证日期，格式为字符串，初始为空字符串
        voucherDate:'',
        // 是否为结转凭证，布尔类型，初始为 false
        carryForward: false,
      },
      // 凭证明细，初始为空数组
      voucherItems: [],
      // 存储当前日期
      currentDate: '',
      // 存储凭证选择的数据，初始为空数组
      voucherSelect: [],
      // 加载中状态，初始为 false
      loading: false,
      //可用状态
      zhejiu:true,
      baocun:true,
      //折旧记录
      depreciationData:[],
      //折旧凭证id
      voucherId:'',
      //部门信息
      auxiliary: [],
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
  },
  watch: {
    // 监听 currentAccountSets 属性变化
    currentAccountSets() {
      // 获取当前会计期间
      this.accountDate = this.currentAccountSets.accountDate;
    },
    // 监控 accountDate 的变化
    accountDate(newVal, oldVal) {
      // 这里可以添加你需要执行的逻辑
      // 例如，重新加载数据
      this.loadList();
      this.loadFixed();
    }
  },
  methods: {

    //获取会计期间 和折旧期间
    edit(){
      if (this.loading) {
        return;
      }
      // 检查是否已执行预加载
      if (this.form.code === 9999 || !this.form.code) {
        this.$Message.warning('请先点击"预加载"按钮获取凭证号！');
        return;
      }

      const accountMoment = moment(this.accountDate);
      const year = accountMoment.year();
      const month = accountMoment.month()+1;

      // 调用结账列表 API，检查当前期间是否已结账
      this.$api.checkout.list().then(({ data }) => {
        // 查找当前会计期间的结账状态
        const currentPeriod = data.find(item =>
            item.checkYear === year && item.checkMonth === month
        );

        // 如果找到该期间且状态为已结账（status === 2）
        if (currentPeriod && currentPeriod.status === 2) {
          this.$Message.error(` ${year}年${month}月 已结账，不能进行折旧操作！`);
          this.zhejiu = true;
          return;
        }

        // 继续原有的折旧期间检查逻辑
        const matchedItems = this.datas.filter(item => {
          const itemMoment = moment(item.checkDate);
          return itemMoment.isValid() && itemMoment.year() === year && itemMoment.month()+1 === month;
        });
        if (matchedItems.length > 0) {
          this.$Message.error('当前选择的会计期间已存在折旧数据，无法再次计提折旧。',0);
          this.zhejiu=true;
        }else{
          this.getAssets2();
        }
      }).catch(error => {
        console.error('检查结账状态失败:', error);
        this.$Message.error('检查结账状态失败，请稍后重试');
      });
      },

    /**
     * 加载凭证编号的方法。
     * 该方法会调用 API，根据当前选择的凭证字号和凭证日期，从后端获取对应的凭证编号，
     * 并将获取到的凭证编号赋值给表单的 `code` 属性。
     */
    async loadCode() {
      this.loading = true;
      try {
        // 重新加载最新数据
        await Promise.all([this.loadList(), this.loadFixed()]);

        // 检查当前会计期间是否已结账
        const accountMoment = moment(this.accountDate);
        const year = accountMoment.year();
        const month = accountMoment.month()+1;

        // 调用结账列表 API，检查当前期间是否已结账
        const { data: checkoutData } = await this.$api.checkout.list();
        const currentPeriod = checkoutData.find(item =>
            item.checkYear === year && item.checkMonth === month
        );

        // 如果找到该期间且状态为已结账（status === 2），则不允许预加载
        if (currentPeriod && currentPeriod.status === 2) {
          this.$Message.error(`${year}年${month}月 已结账，不能进行折旧操作！`);
          return;
        }


        if (this.fixedAssets.length===0) {
          this.$Message.error('未找到固定资产数据，请先录入资产信息！');
          return;
        }

        // 调用 API 并传入当前凭证字号和凭证日期，请求对应的凭证编号
        const { data } = await this.$api.voucher.loadCode({
          word: this.form.word,
          currentAccountDate: this.accountDate
        });

        // 将从后端获取的凭证编号赋值给表单的 code 属性
        this.form.code = data;
        this.auxiliaryInfoToAssets();

        //获得折旧凭证号后开始计算
        this.zhejiu=false;
        this.$Message.success('预加载成功，请确认信息后点击"计提折旧"');
      } catch (error) {
        console.error('预加载失败:', error);
        this.$Message.error('预加载失败：' + (error.message || '未知错误'));
      } finally {
        this.loading = false;
      }
    },


    // 将部门映射到固定资产数据中
    auxiliaryInfoToAssets() {
      // 创建部门信息的映射表，以提高查找效率
      const deptMap = {};
      this.auxiliary.forEach(deptItem => {
        deptMap[deptItem.id] = {
          accountingCategoryId: deptItem.accountingCategoryId,
          code: deptItem.code,
          enable: deptItem.enable,
          id: deptItem.id,
          name: deptItem.name
        };
      });

      // 为每个固定资产添加辅助核算信息
      this.fixedAssets.forEach(asset => {
        if (asset.deptId && deptMap[asset.deptId]) {
          // 添加辅助核算信息
          asset.auxiliary = [{
            accountingCategoryId: deptMap[asset.deptId].accountingCategoryId,
            code: deptMap[asset.deptId].code,
            enable: deptMap[asset.deptId].enable,
            id: deptMap[asset.deptId].id,
            name: deptMap[asset.deptId].name
          }];
        } else {
          asset.auxiliary = [];
        }
      });
    },


    //获取符合条件的资产数据
    async getAssets2(){
      try {
        this.loading = true;
        //资产表里找打符合折旧的数据->上次折旧日期小于当前选择日期，且剩余折旧次数小于总次数->开始折旧
        const assets = this.fixedAssets.filter(item => {
          // 开始折旧日期小于等于当前选择日期，
          const startDate =  new Date(item.checkDate) <= new Date(this.accountDate);
          //  剩余折旧月数大于 0
          const remainingDepreciation = item.remainingUseMonth >0;
          // //  上次折旧日期小于当前选择日期
          // const lastDepreciationDate = new Date(item.entryDate) <= new Date(this.accountDate) || isNaN(new Date(item.entryDate).getTime());
          const lastDepreciationDate = (!item.entryDate || item.entryDate === "" || new Date(item.entryDate) <= new Date(this.accountDate));
          // 排除已处置的资产
          const notDisposed = item.disposalFlag !== 1;
          return startDate && remainingDepreciation && lastDepreciationDate && notDisposed;

        });

        //生成凭证
        if (assets.length > 0) {
          // 计算合计借方金额并生成明细
          let tmp = localStorage.getItem('voucherSelect');
          if (tmp) {
            this.voucherSelect = JSON.parse(tmp);
          }

          const voucherDetails = [];
          const accountDateMonth = moment(this.accountDate).format('YYYY-MM');

          // 遍历所有固定资产，为需要计提折旧的资产生成凭证分录
          assets.forEach(item => {
            if (item.currentMonthDepreciation) {
              const debitSubject = this.voucherSelect.find(subject => subject.id === item.debitSubject);
              if (debitSubject) {
                voucherDetails.push({
                  auxiliary: item.auxiliary,
                  debitAmount: item.currentMonthDepreciation,
                  subjectId: debitSubject.id,
                  direction: debitSubject.direction,
                  subjectName: debitSubject.code + '-' + debitSubject.name,
                  subjectCode: debitSubject.code,
                  auxiliaryTitle: '_' + item.auxiliary[0].code + "_" + item.auxiliary[0].name,
                  summary: `${accountDateMonth}月份折旧费`
                });
              }

              const creditSubject = this.voucherSelect.find(subject => subject.id === item.creditSubject);
              if (creditSubject) {
                voucherDetails.push({
                  auxiliary: item.auxiliary,
                  creditAmount: item.currentMonthDepreciation,
                  subjectId: creditSubject.id,
                  direction: creditSubject.direction,
                  subjectName: creditSubject.code + '-' + creditSubject.name,
                  subjectCode: creditSubject.code,
                  auxiliaryTitle: '_' + item.auxiliary[0].code + "_" + item.auxiliary[0].name,
                  summary: `${accountDateMonth}月份折旧费`
                });
              }
            }
          });

          //对 voucherDetails 按 subjectId + auxiliaryTitle 进行合并
          const mergedVoucherDetails = [];
          const summaryMap = new Map();
          voucherDetails.forEach(item => {
            const key = `${item.subjectId}_${item.auxiliaryTitle || ''}`;

            if (summaryMap.has(key)) {
              const existingItem = summaryMap.get(key);
              existingItem.debitAmount = (existingItem.debitAmount || 0) + (item.debitAmount || 0);
              existingItem.creditAmount = (existingItem.creditAmount || 0) + (item.creditAmount || 0);
            } else {
              summaryMap.set(key, {
                auxiliary: item.auxiliary && item.auxiliary.length > 0 ? item.auxiliary : null,
                debitAmount: item.debitAmount || 0,
                creditAmount: item.creditAmount || 0,
                subjectId: item.subjectId,
                direction: item.direction,
                subjectName: item.subjectName,
                subjectCode: item.subjectCode,
                auxiliaryTitle: item.auxiliaryTitle || '',
                summary: item.summary
              });
            }
          });

          mergedVoucherDetails.push(...summaryMap.values());
          // console.log('合并前:', voucherDetails.length, '合并后:', mergedVoucherDetails.length);
          this.voucherItems = mergedVoucherDetails;

          //修改资产表里数据
          assets.forEach(item => {
            item.useMonth++; //已折旧月数加1
            item.remainingUseMonth--; //剩余折旧月数减1
            item.entryDate = this.accountDate; //上次折旧日期
            //资产净值=剩余折旧月数*每月折旧额
            item.totalDepreciation = item.remainingUseMonth * item.currentMonthDepreciation;
          });


          //凭证日期
          this.form.voucherDate = this.accountDate;

          // 【关键】按顺序执行异步操作
          // 1. 先保存凭证
          const voucherResult = await this.$api.voucher.save(
              Object.assign({}, this.form, { details: this.voucherItems, createMember: this.User.id })
          );

          // console.log('凭证保存结果:', voucherResult);
          if (!voucherResult.success) {
            throw new Error(voucherResult.msg || '凭证保存失败');
          }
          this.voucherId = voucherResult.data.id;
          this.$Message("亲，凭证保存成功！");

          // 2. 再保存折旧记录（依赖凭证 ID）
          const depreciationData = {
            checkDate: this.accountDate,
            checkYear: new Date(this.accountDate).getFullYear(),
            checkMonth: new Date(this.accountDate).getMonth() + 1,
            status: "已计提折旧",
            voucherId: this.voucherId,
          };

          const depResult = await this.$api.assets.depreciation.save(depreciationData);

          if (!depResult.success) {
            throw new Error(depResult.msg || '折旧记录保存失败');
          }

          this.$Message("亲，折旧记录已保存！");


          // 3. 最后更新资产数据
          try {

            await this.$api.assets.assets.batchUpdate(assets);
            this.$Message("亲，资产数据已更新！");
          } catch (assetError) {
            // 资产更新失败不影响整体流程，但需要记录日志
            this.$Message("资产数据已更新，自动折旧已完成！");
          }
          // 4. 刷新列表
          await this.loadList();

          // 5. 更新状态
          this.loading = false;
          this.zhejiu = true;
          // 重置凭证号，下次需要重新预加载
          this.form.code = 9999;
        } else {
          this.loading = false;
          this.zhejiu = true;
          this.$Message("亲，没有需要折旧的资产！");
        }
      } catch (error) {
        console.error('折旧处理失败:', error);
        this.$Message.error('操作失败：' + (error.message || '未知错误'));
        this.loading = false;
        this.zhejiu = true;
      }
    },


    // 查看凭证
    viewVoucher(data) {
      this.$router.push({ name: 'VoucherForm', params: { voucherId: data.voucherId } });
    },




    //编辑数据
    /**
     * 加载折旧列表数据
     * 获取资产折旧列表，并对数据进行排序和凭证信息补充处理
     */
    loadList() {
      return this.$api.assets.depreciation.list().then(({ data }) => {


        // 对数据按 checkDate 降序排序
        if (data) {
          data.sort((a, b) => {
            const dateA = new Date(a.checkDate);
            const dateB = new Date(b.checkDate);
            return dateB - dateA;
          });
          // 为每个折旧记录获取对应的凭证信息
          const voucherPromises = data.map(item => {
            if (item.voucherId) {
              return this.$api.voucher.load(item.voucherId).then(voucherResponse => {
                if (voucherResponse.success) {
                  // 将凭证的 word 和 code 添加到数据中
                  item.voucherName = `${voucherResponse.data.word}-${voucherResponse.data.code}`;
                } else {
                  item.voucherName = '凭证信息获取失败';
                }
                return item;
              }).catch(() => {
                // 如果获取凭证信息失败，返回原始项目
                item.voucherName = '凭证信息获取失败';
                return item;
              });
            } else {
              // 如果没有 voucherId，设置默认值
              item.voucherName = '无凭证';
              return Promise.resolve(item);
            }
          });
          // 等待所有 Promise 完成
          return Promise.all(voucherPromises).then(() => {
            this.datas = data || [];
            return data;
          });
        }else {
          this.datas = [];
          return [];
        }
      }).catch(error => {
        console.error('加载折旧列表失败:', error);
        this.$Message.error('加载折旧列表失败');
        this.datas = [];
        return [];
      });
    },
    /**
     * 加载固定资产列表数据
     * 该方法调用API接口获取固定资产数据，并将结果存储到组件的fixedAssets属性中
     */
    loadFixed(){
      this.$api.assets.assets.list().then(({data}) => {
        this.fixedAssets = data || [];
        // console.log('加载的固定资产数据:', this.fixedAssets.length, '条记录');
      })
    },


    /**
     * 删除折旧信息
     * @param {Object} data - 折旧信息对象
     */
    remove(data) {
      // 先检查当前会计期间是否已结账
      const checkDate = new Date(data.checkDate);
      const year = checkDate.getFullYear();
      const month = checkDate.getMonth() + 1;

      this.$api.checkout.list().then(({ data: checkoutData }) => {
        // 查找当前会计期间的结账状态
        const currentPeriod = checkoutData.find(item =>
          item.checkYear === year && item.checkMonth === month
        );

        // 如果找到该期间且状态为已结账（status === 2），则不允许撤销
        if (currentPeriod && currentPeriod.status === 2) {
          this.$Message.error(`${year}年${month}月 已结账，不能撤销折旧！`);
          return;
        }

        // 如果期间未结账，显示确认对话框
        this.$Confirm("确认撤销这次折旧?").then(() => {
          //撤销逻辑，找到资产表里上次折旧日期与
          const assets = this.fixedAssets.filter(item => {
            return item.entryDate === data.checkDate;
          });
            // 添加资产数据存在性检查
          if (assets.length === 0) {
            this.$Message("没有找到可撤销的资产数据");
            return;
          }
          //解决上次折旧日期问题
          const secondCheckDate = this.datas.length >= 2 ? this.datas[1].checkDate : null;
          //修改资产信息
          assets.forEach(item => {
            item.useMonth--; //已折旧月数减1
            item.remainingUseMonth++; //剩余使用月数加1
            // item.entryDate = secondCheckDate; //更新资产折旧日期

            // 如果secondCheckDate小于起始折旧日期，则entryDate=null
            let newEntryDate = secondCheckDate;
            if (secondCheckDate && item.checkDate) {
              const secondDate = new Date(secondCheckDate);
              const startDate = new Date(item.checkDate);
              if (secondDate < startDate) {
                newEntryDate = null;
              }
            }
            item.entryDate = newEntryDate; //更新资产折旧日期

            //更新资产净值=剩余使用月数*月折旧额
            item.totalDepreciation = item.remainingUseMonth * item.currentMonthDepreciation;
          });

          //保存资产信息
          this.$api.assets.assets.batchUpdate(assets)
              .then((response) => {
                // console.log("后端响应:", response);
              })
              .catch((error) => {
                // console.error("保存失败:", error);
              });
          //删除凭证信息
          if (data.voucherId) {
            this.$api.voucher.delete(data.voucherId).then();
          }
          //删除折旧信息
          this.$api.assets.depreciation.delete(data.id).then(() => {
            this.$Message("折旧信息已撤销成功！");
            this.loadList();
          });

        }).catch((error) => {
          // console.error('用户取消撤销操作:', error);
        });
      }).catch(error => {
        console.error('检查结账状态失败:', error);
        this.$Message.error('检查结账状态失败，请稍后重试');
      });
    },
// ... existing code ...



    /**
     * 加载部门数据
     */
    loadDept() {
      // 调用 API 获取辅助核算类别列表
      this.$api.setting.accountingCategory.list().then(({data}) => {
        const departmentItem = data.find(val => val.name === '部门');
        // 如果找到了部门类别
        if (departmentItem) {
          // 获取该类别下的详细信息
          this.$api.setting.accountingCategoryDetails.list(departmentItem.id).then(({ data: deptData }) => {
            this.auxiliary = deptData.records || [];
          });
        }
      });

    }
  },
  mounted() {
    this.loadList();
    this.loadFixed();
    this.loadDept(); // 加载部门数据
  },
}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}

</style>